import CityOne from 'src/assets/SuccessStories/city_2-min.avif'
import LionsOne from 'src/assets/SuccessStories/clinica_2-min.avif'
import ClinicaOne from 'src/assets/SuccessStories/clinicaclub.avif'
import ViveOne from 'src/assets/SuccessStories/vive_2-min.avif'
import TaringaOne from 'src/assets/SuccessStories/TaringaApp.avif'
import VivemasLogo from 'src/assets/SuccessStories/vive_logo.avif'
import LionsClubLogo from 'src/assets/SuccessStories/ClubDeLeones.avif'
import TaringaLogo from 'src/assets/Testimonials/taringa_11zon.avif'
import CityPrimeLogo from 'src/assets/SuccessStories/cityprime.avif'
import ClubdeLeonesClinicaLogo from '../assets/SuccessStories/clubdeleonesclinica.avif'
import {
    animationVariantsRightSuccess,
    animationVariantsSuccess,
} from 'src/theme/animations/swipeIn'
import { useTranslations } from 'src/provider/LocaleProvider'
import { SuccessLabels } from 'src/types'

export function SuccessStoriesLabels() {
    const t = useTranslations()
    const ContentSuccessStories: SuccessLabels[] = [
        {
            id: 1,
            title: `${t('successStories.stories.taringa.name')}`,
            category: `${t('successStories.stories.taringa.category')}`,
            functionality: `${t(
                'successStories.stories.taringa.functionality'
            )}`,
            solution: `${t('successStories.stories.taringa.solution')}`,
            results: `${t('successStories.stories.taringa.results')}`,
            initialChallenge: `${t(
                'successStories.stories.taringa.initialChallenge'
            )}`,
            typography: `${t('successStories.stories.taringa.typography')}`,
            cover: TaringaLogo,
            background: '#fff',
            client: 'Taringa',
            reference: 'https://www.taringa.net/',
            referenceApple:
                'https://apps.apple.com/co/app/taringa/id6445920957',
            referencePlay:
                'https://play.google.com/store/apps/details?id=net.taringa.mobileapp&hl=en_US',
            firstImage: TaringaOne,
            address: true,
            animationImage: animationVariantsRightSuccess,
            animationText: animationVariantsSuccess,
            noting: true,
        },
        {
            id: 2,
            title: `${t('successStories.stories.viveplus.name')}`,
            category: `${t('successStories.stories.viveplus.category')}`,
            functionality: `${t(
                'successStories.stories.viveplus.functionality'
            )}`,
            solution: `${t('successStories.stories.viveplus.solution')}`,
            results: `${t('successStories.stories.viveplus.results')}`,
            initialChallenge: `${t(
                'successStories.stories.viveplus.initialChallenge'
            )}`,
            typography: `${t('successStories.stories.viveplus.typography')}`,
            cover: VivemasLogo,
            background: '#fff',
            client: 'Air-e',
            reference: 'https://vivesmas.co',
            referenceApple:
                'https://apps.apple.com/co/app/vive-mas/id1630842847',
            referencePlay:
                'https://play.google.com/store/apps/details?id=com.vivemas',
            firstImage: ViveOne,
            address: false,
            animationImage: animationVariantsSuccess,
            animationText: animationVariantsRightSuccess,
            noting: true,
        },
        {
            id: 3,
            title: `${t('successStories.stories.lionsclub.name')}`,
            category: `${t('successStories.stories.lionsclub.category')}`,
            functionality: `${t(
                'successStories.stories.lionsclub.functionality'
            )}`,
            solution: `${t('successStories.stories.lionsclub.solution')}`,
            results: `${t('successStories.stories.lionsclub.results')}`,
            initialChallenge: `${t(
                'successStories.stories.lionsclub.initialChallenge'
            )}`,
            typography: `${t('successStories.stories.lionsclub.typography')}`,
            cover: LionsClubLogo,
            background: '#212A97',
            client: 'Lions Club',
            reference: 'https://lionskidsightcolombia.org/',
            firstImage: LionsOne,
            address: true,
            webAndApp: false,
            animationImage: animationVariantsRightSuccess,
            animationText: animationVariantsSuccess,
            noting: false,
        },
        {
            id: 4,
            title: `${t(
                'successStories.stories.puertocolombialionsclubclinic.name'
            )}`,
            category: `${t(
                'successStories.stories.puertocolombialionsclubclinic.category'
            )}`,
            functionality: `${t(
                'successStories.stories.puertocolombialionsclubclinic.functionality'
            )}`,
            solution: `${t(
                'successStories.stories.puertocolombialionsclubclinic.solution'
            )}`,
            results: `${t(
                'successStories.stories.puertocolombialionsclubclinic.results'
            )}`,
            initialChallenge: `${t(
                'successStories.stories.puertocolombialionsclubclinic.initialChallenge'
            )}`,
            typography: `${t(
                'successStories.stories.puertocolombialionsclubclinic.typography'
            )}`,
            cover: ClubdeLeonesClinicaLogo,
            background: '#fff',
            reference: 'https://clinicaclubdeleonesptocol.com/',
            client: 'Puerto Colombia Lions Club Clinic',
            firstImage: ClinicaOne,
            address: false,
            webAndApp: false,
            animationImage: animationVariantsSuccess,
            animationText: animationVariantsRightSuccess,
            noting: false,
        },
        {
            id: 5,
            title: `${t('successStories.stories.cityprime.name')}`,
            category: `${t('successStories.stories.cityprime.category')}`,
            functionality: `${t(
                'successStories.stories.cityprime.functionality'
            )}`,
            solution: `${t('successStories.stories.cityprime.solution')}`,
            results: `${t('successStories.stories.cityprime.results')}`,
            initialChallenge: `${t(
                'successStories.stories.cityprime.initialChallenge'
            )}`,
            typography: `${t('successStories.stories.cityprime.typography')}`,
            cover: CityPrimeLogo,
            background: '#483E69',
            client: 'City Prime',
            reference: 'https://www.cityprime.com.co/',
            firstImage: CityOne,
            address: true,
            animationImage: animationVariantsRightSuccess,
            animationText: animationVariantsSuccess,
            noting: false,
        },
    ]
    return { ContentSuccessStories }
}
